import { Plot } from '../../core/plot';
import { Adaptor } from '../../core/adaptor';
import { BoxOptions } from './types';
import { adaptor } from './adaptor';
import { transformData } from './utils';
import { DEFAULT_OPTIONS, OUTLIERS_VIEW_ID } from './constant';
export type { BoxOptions };

export class Box extends Plot<BoxOptions> {
  /**
   * è·å é»è®¤éç½®é¡¹
   * ä¾å¤é¨ä½¿ç¨
   */
  static getDefaultOptions(): Partial<BoxOptions> {
    return DEFAULT_OPTIONS;
  }

  /** å¾è¡¨ç±»å */
  public type: string = 'box';

  /**
   * @override
   * @param data
   */
  public changeData(data) {
    this.updateOption({ data });
    const { yField } = this.options;

    const outliersView = this.chart.views.find((v) => v.id === OUTLIERS_VIEW_ID);
    if (outliersView) {
      outliersView.data(data);
    }

    this.chart.changeData(transformData(data, yField));
  }

  /**
   * è·å ç®±åå¾ é»è®¤éç½®é¡¹
   */
  protected getDefaultOptions(): Partial<BoxOptions> {
    return Box.getDefaultOptions();
  }

  /**
   * è·å ç®±åå¾ çééå¨
   */
  protected getSchemaAdaptor(): Adaptor<BoxOptions> {
    return adaptor;
  }
}
